export const constants = {
    getVerifyUserPinEndPoint: '/pages/sms/ess/v3/ws/rest/pub/ssr/ssrbyadmin/verifypin',
    EXCEEDED_ATTEMPTS:'EXCEEDED_ATTEMPTS',
    ALREADY_REGISTERED:'ALREADY_REGISTERED',
    INVALID_USERPIN:'INVALID_USERPIN',
    INVALID_PIN: 'INVALID_PIN'
};
